import { useLocalStorage } from "react-use";
import moment from "moment";
import useSessionStorage from "./SessionStorage";

export interface PreregisterDto {
  id: number;
  mobileId: number;
  emailId: number;
  expiryDate: string | null;
  blockTillDate: string | null;
  status: number;
}

export interface AccountData {
  id: number;
  companyName: string;
  taxRegistrationNumber: string;
  industryId: number;
  companySizeId: number;
  companyWebsite: string;
  email: string;
  password: string;
}

export const usePreregisterData = () => {
  const [preregisterData, setPreregisterData] = useSessionStorage("preregister-data", undefined);

  const isStillBlocked = preregisterData?.blockTillDate && moment(preregisterData?.blockTillDate).utc().isAfter(Date.now());
  const isStillValid = preregisterData?.expiryDate && moment(preregisterData?.expiryDate).utc().isAfter(Date.now());

  const customerStatus = preregisterData?.status;

  return {
    preregisterData,
    setPreregisterData,
    isStillBlocked,
    isStillValid,
    customerStatus
  };
};
